import React from "react";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Modal from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./SimpleModalWithCenteredButtons.module.css";

interface ButtonConfig {
  text: string;
  onClick: () => void;
}

interface Props {
  title: string;
  text: string;
  primaryButton: ButtonConfig;
  secondaryButton: ButtonConfig;
  onClose: () => void;
  className?: string;
  isOpen?: boolean;
}

const SimpleModalWithCenteredButtons: React.FC<Props> = ({
  title,
  text,
  primaryButton,
  secondaryButton,
  onClose,
  className,
  isOpen = true,
}) => {
  return (
    <Modal
      className={toClassName(styles.modal, className)}
      closeModal={onClose}
      showCloseButton={true}
      isOpen={isOpen}
    >
      <Text variant="title2">{title}</Text>

      <Text className={styles.bodyText}>{text}</Text>

      <div className={styles.footer}>
        <Button
          text={secondaryButton.text}
          variant="outlined"
          buttonType="secondary"
          onClick={secondaryButton.onClick}
          className={styles.actionButton}
        />

        <Button
          text={primaryButton.text}
          variant="outlined"
          buttonType="warning"
          onClick={primaryButton.onClick}
          className={styles.actionButton}
        />
      </div>
    </Modal>
  );
};

export default SimpleModalWithCenteredButtons;
